export default __webpack_public_path__ + "static/media/Logo_1.475e38b7.svg";